import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamReportConfigAction } from '../fetchTeamReportConfig/action';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* deleteTeamReportConfigSaga(action) {
  try {
    const { id, teamId } = action.payload;
    
    if (!id) {
      throw new Error('Report ID is required');
    }
    
    yield call([backendClient, backendClient.delete], `reports/${id}`);
    
    yield put(fetchAnalyticTeamReportConfigAction({ teamId }));
    
    yield put(showSnackbar({
      message: 'Report deleted successfully',
      severity: 'success',
    }));
  } catch (err) {
    bugsnagClient.notify(err);
    console.error('Failed to delete analytic report configuration', err?.message);
    yield put(showSnackbar({
      message: 'Failed to delete report',
      severity: 'error',
    }));
  }
}